module.exports = __webpack_public_path__ + "static/media/drop-down-arrow-user-group.27bb0c8f.svg";